// 教学班级
export const CLASS_LIST = 'class_list'
export const CLASS_INFO = 'class_info'
export const BASIC_CLASS = 'basic_class'
export const CLASS_STUDENT_LIST = 'class_student_list'
export const CLASS_GROUP_STU_LIST = 'class_group_stu_list'
export const CLASS_GROUP_LIST = 'class_group_list'
export const CLASS_WACOM = 'class_wacom'